<template>
  <div>
    <p class="text-2xl mb-6">Liste des Sites</p>
    <v-col cols="12"> <sites-table></sites-table> </v-col>
  </div>
</template>

<script>
import SitesTable from "@/components/admin/site/tables/SitesTable";

export default {
  name: "SiteList",
  components: {
    SitesTable,
  },
};
</script>

<style scoped></style>
